module.exports = __webpack_public_path__ + "img/shot_bigtx20022502.023652a1.png";